import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Res, File, ListParams } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  filterDataSubject = new Subject<any>();
  fileListDataSubject = new Subject<any>();
  pathToImgNoAvatar: string = '/assets/images/no-avatar.png';
  pathToImgNoImageAvailable: string = '/assets/images/no-image-available.png';
  fileError: string;
  iconExts = ['3ds', 'aac', 'ai', 'avi', 'bmp', 'cad', 'cdr', 'css', 'dat', 'dll', 'dmg', 'doc', 'DOCX', 'eps', 'fla', 'flv', 'gif', 'html', 'indd', 'iso', 'jpg', 'js', 'midi', 'mov', 'mp3', 'mpg', 'pdf', 'php', 'png', 'ppt', 'ps', 'psd', 'raw', 'sql', 'svg', 'tif', 'txt', 'wmv', 'xls', 'xml', 'zip', 'rar', 'xlsx', 'docx']

  constructor(
    private api: ApiService,
    private apiBasic: ApiBasicService
  ) { }

  /**
   * 
   * @param id 
   * @returns 
   */
  getUsageSpace(id: string): Observable<Res> {

    return this.api.get('getOrgTotalUsageSpace', id, 'private');
  }

  /**
  * 
  * @param params List
  * @returns Observable<Res>
  */
  getList(params: ListParams): Observable<Res> {

    return this.api.post('file_list/flex', params, 'private', 'files');
  }

  /**
   * 
   * @param fileName string
   * @returns string
   */
  checkIconExt(fileName: string): string {

    let arr: string[] = fileName.split('.');

    let i: number = this.iconExts.indexOf(arr[(arr.length - 1)]);

    if (i > -1) {

      return this.iconExts[i];
    }

    return 'other';
  }

  /**
   * 
   * @param size number
   * @returns string
   */
  convertationToMb(size: number): string {

    let num: number = (size / 1024) / 1024;

    return num.toFixed(2);
  }


  /**
   * 
   * @param size number
   * @param progress number
   * @returns string
   */
  calculationOfLoadedVolume(size: number, progress: number): string {

    let onePercent: number = size / 100;

    let currentVolume: number = progress * onePercent;

    return this.convertationToMb(currentVolume);
  }


  /**
   * 
   * @param fileType string
   * @returns boolean
   */
  checkAllowedTypes(fileType: string): boolean {

    const allowedTypes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png'
    ];

    if (allowedTypes.indexOf(fileType) == -1) {

      this.fileError = 'Для загрузки допускаются только следующие типы файлов: .jpg, .png';
      return false;
    }

    return true;
  }


  /**
   * 
   * @param fileSize number
   * @returns boolean
   */
  checkMaxSize(fileSize: number): boolean {

    const maxSize: number = 5242880; // 5MB

    if (fileSize > maxSize) {

      this.fileError = 'Максимально допустимый размер файла ' + ((maxSize / 1024) / 1024) + 'Мб';
      return false;
    }

    return true;
  }


  /**
   * 
   * @param data any
   * @returns File
   */
  getObjectWithDefaultData(data: any): File {

    let path: string = '';

    if (data.hasOwnProperty('path')) {

      switch (data.path) {
        case 'pathToImgNoAvatar':
          path = this.pathToImgNoAvatar;
          break;
        case 'pathToImgNoImageAvailable':
          path = this.pathToImgNoImageAvailable;
          break;
        default:
          path = data.path;
          break;
      }
    }

    return {
      id: data.hasOwnProperty('id') ? data.id : 0,
      name: data.hasOwnProperty('name') ? data.name : '',
      basename: data.hasOwnProperty('basename') ? data.basename : '',
      size: data.hasOwnProperty('size') ? data.size : 0,
      mime: data.hasOwnProperty('mime') ? data.mime : '',
      extension: data.hasOwnProperty('extension') ? data.extension : '',
      path: path
    }
  }

  /**
   * 
   * @param objectName 
   * @param params 
   * @returns 
   */
  addFileToCategory(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/category', params, 'private', 'files');
  }

  /**
   * 
   * @param params 
   * @returns Observable<any>
   */
  upload(methodname, params): Observable<any> {

    // return this.httpClient.post('files-service/api/v1/uploadFile', params, {
    //    reportProgress: true,  
    //    observe: 'events'  
    // });  

    return methodname == 'uploadPriceListFile' ? this.api.uploadKaspi(methodname, params, 'private', 'integrationKaspi') : this.api.upload(methodname, params);
  }

  // /**
  //  * 
  //  * @param id number
  //  * @returns Observable<any>
  //  */
  // delete(id: any): Observable<Res> {

  //   return this.api.delete('files/destroy', id);
  // }

  /**
  * 
  * @param id number
  * @returns Observable<any>
  */
  delete(id: any): Observable<Res> {

    return this.apiBasic.delete('orgs_files', id);
  }

  /**
  * 
  * @param fileId 
  * @returns 
  */
  getImageContent(fileId: string): Observable<any> {

    return this.api.getImage('getImageContent', fileId, 'private');
  }


  /**
   * 
   * @param fileId 
   * @returns 
   */
  deleteMapping(data): Observable<any> {

    return this.api.delete('file', data, 'private', 'files');
  }


  /**
  * 
  * @param fileId 
  * @returns 
  */
  getImage(fileId: string): Observable<any> {

    return this.api.getImage('getImage', fileId, 'private');
  }


  /**
   * 
   * @param productId 
   * @returns 
   */
  getImages(productId: string): Observable<any> {

    return this.api.get('getAllProductImages', productId, 'private', 'files');
  }


  /**
   * 
   * @param fileId 
   * @returns 
   */
  getFileInfo(fileId: string): Observable<any> {

    return this.api.getFileInfo('getFileInfo', fileId, 'private');
  }

  /**
   * 
   * @param fileId 
   * @returns 
   */
  getFileInfoForEdit(fileId: string): Observable<any> {

    return this.api.getFileInfo('fileCard', fileId, 'private');
  }


  /**
   * 
   * @param fileName 
   * @param fileId 
   */
  downloadFile(fileName: string, fileId: string): void {

    this.api.downloadFile('downloadFile/' + fileId).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        // this.download(response.url, fileName);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }

  /**
   * 
   * @param fileName 
   * @param fileId 
   */
  downloadMappingTemplateExpamleFile(mapping_id: string, fileName: string): void {

    console.log("FILE NAME: ", fileName);

    this.api.downloadFile('downloadMappingCsvTemplate/' + mapping_id).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        // this.download(response.url, 'test.csv');
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));;
        downloadLink.download = fileName + '.csv';
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }

  /**
   * 
   * @param fileName 
   * @param fileId 
   */
  downloadSelectedFile(file_id: string[]): void {

    this.api.downloadFile('downloadFiles/' + file_id).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        // this.download(response.url, 'test.csv');
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));;
        downloadLink.download = 'Архив'.concat(new Date().getTime().toString()) + '.zip';
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }


  /**
  * 
  * @param fileName 
  * @param fileId 
  */
  downloadData(ids, fileName): void {

    console.log("IDS: ", ids, "FILE_NAME: ", fileName);


    this.api.downloadMediaFile('exportProducts', ids).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }


  /**
  * 
  * @param fileName 
  * @param fileId 
  */
  downloadMediaFiles(ids, fileName): void {

    console.log("IDS: ", ids, "FILE_NAME: ", fileName);


    this.api.downloadMediaFile('downloadMediaFiles', ids).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }

  /**
  * 
  * @param fileName 
  * @param fileId 
  */
  downloadWithSettings(methodName: string, settingsData: any, fileName: string = ''): void {

    this.api.downloadMediaFile(methodName, settingsData).subscribe((response: any) => {
      console.log("RESPONSE: ", response);

      if (response != null) {

        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob([response.body], { type: response.body.type }));
        downloadLink.download = methodName == 'downloadWithSettings' ? 'Архив'.concat(new Date().getTime().toString()) + '.zip' : fileName;
        downloadLink.click();
        downloadLink.remove();
      }
    });
  }


  /**
  * 
  */
  getDownloadHistoryByOrg(org_id: string): Observable<any> {

    return this.api.getFileInfo('getDownloadHistoryByOrg', org_id, 'private');
  }

  /**
   * 
   * @param file 
   * @param fileType 
   * @param fileName 
   */
  async download(url, fileName) {

    let downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
    downloadLink.remove();
  }

  /**
   * 
   * @param response 
   */
  async checkingResponseWhenDownloadingFile(body: any): Promise<boolean> {

    let result = await body.text().then(function (res) {

      if (body.type != 'application/json') {

        return { type: 'succes', text: 'OK' }
      }
      console.log("RES: ", body.type)
      let obj = JSON.parse(res);

      if (obj.status != undefined) {

        switch (obj.status) {
          case 0:
            return { type: 'error', text: obj.message }
          case 1:
            return { type: 'succes', text: obj.message }
          case 2:
            return { type: 'warning', text: obj.message }
        }
      }
    })
      .catch(function (err) {

        return { type: 'error', text: err };
      });



    if (!result || result.type != 'succes') {

      // if(result.text == 'INVALID_TOKEN' || result.text == 'TOKEN_NOT_FOUND'){

      //   setTimeout(()=>{ this.authService.login(); }, 1500);
      //   result.text = 'Для получения доступа к файлам необходимо авторизоваться в системе.';
      // }
      // else if(result.text == 'PROTOCOL_NOT_FOUND'){

      //   result.text = 'Протокол не доступен для скачивания, так как еще не сохранен в системе.';
      // }

      // this.snackBar.open(result.type, result.text);
      // console.log(result.type + ': ', result.text);

      return false;
    }
    else {

      return true;
    }
  }

  /**
 * 
 * @param params any
 * @returns Observable<Res>
 */
  edit(params: any): Observable<Res> {

    return this.apiBasic.edit('file', params);
  }


  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('file', params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  updateFile(params: any): Observable<Res> {

    return this.api.post('updateFile', params, 'private', 'files');
  }

  /**
   * 
   * @param data 
   */
  setFilterData(data: any): void {

    this.filterDataSubject.next(data);
  }

  /**
    * Method to listen for language change
    * @returns Observable<any>
    */
  listenerFilterData(): Observable<any> {

    return this.filterDataSubject.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setFileListData(data: any): void {

    this.fileListDataSubject.next(data);
  }

  /**
    * Method to listen for language change
    * @returns Observable<any>
    */
  listenerFileListData(): Observable<any> {

    return this.fileListDataSubject.asObservable();
  }


}
